import React, { useContext, useState } from "react";
import ViewOfferDetails from "./ViewOfferDetails";
import { Col, Nav, NavItem, NavLink, Row } from "reactstrap";
import classnames from "classnames";
import { VIEW_OFFER_TABS } from "./constants/initialValues";
import ViewOfferGrants from "./ViewOfferGrants";
import ViewOfferCharges from "./ViewOfferCharges";
import ViewOfferUsage from "./ViewOfferUsage";
import ViewOfferNav from "./ViewOfferNav";
import { ViewOfferContext } from "./context";

const ViewOffer = () => {
  const { rightContentRef } = useContext(ViewOfferContext);
  const [selectedTabToView, setSelectedTabToView] = useState(
    VIEW_OFFER_TABS.OFFER_DETAILS
  );
  const [activeTab, setActiveTab] = useState(VIEW_OFFER_TABS.ONE_TIME);
  const [activeChargeTab, setActiveChargeTab] = useState(
    VIEW_OFFER_TABS.ONE_TIME
  );
  const [activeUsageTab, setActiveUsageTab] = useState(
    VIEW_OFFER_TABS.ONE_TIME
  );
  return (
    <Row className="mt-4">
      <Col lg={2}>
        <ViewOfferNav
          selectedTabToView={selectedTabToView}
          setSelectedTabToView={setSelectedTabToView}
          setActiveTab={setActiveTab}
          setActiveChargeTab={setActiveChargeTab}
          setActiveUsageTab={setActiveUsageTab}
        />
      </Col>
      <Col lg={10}>
        <div className="view-offer-tab-right" ref={rightContentRef}>
          {selectedTabToView === VIEW_OFFER_TABS.OFFER_DETAILS && (
            <ViewOfferDetails />
          )}
          {selectedTabToView === VIEW_OFFER_TABS.GRANTS && (
            <ViewOfferGrants
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          )}
          {selectedTabToView === VIEW_OFFER_TABS.CHARGES && (
            <ViewOfferCharges
              activeTab={activeChargeTab}
              setActiveTab={setActiveChargeTab}
            />
          )}
          {selectedTabToView === VIEW_OFFER_TABS.USAGE && (
            <ViewOfferUsage
              activeTab={activeUsageTab}
              setActiveTab={setActiveUsageTab}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

export default ViewOffer;
